<template>
    <rkm-overlay>
        <rkm-layout-body title="Emissão de senha">
            <rkm-layout-content noCardStyle>
                <Form />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import Form from '@/components/painel-senha/emissao-senha/Form'

export default {
    components: { Form },
}
</script>